(function () {
  function formatDate(date) {
    var weekdays = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
    var months = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
    return weekdays[date.getDay()] + ' ' + date.getDate() + '. ' + months[date.getMonth()];
  }

  function shippingLabel() {
    var date = new Date();
    date.setDate(date.getDate() + 2);
    return formatDate(date);
  }

  function renderShippingDate() {
    var nodes = document.querySelectorAll('[data-hh-juleklem-date]');
    if (!nodes.length) return;
    var label = shippingLabel();
    nodes.forEach(function (node) {
      node.textContent = label;
      node.setAttribute('data-hh-juleklem-rendered', 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', renderShippingDate);
  document.addEventListener('shopify:section:load', renderShippingDate);
  document.addEventListener('shopify:section:select', renderShippingDate);
  document.addEventListener('shopify:section:deselect', renderShippingDate);
  document.addEventListener('variant:change', renderShippingDate);
  document.addEventListener('product:variant-change', renderShippingDate);
  document.addEventListener('change', function (event) {
    var name = event.target && event.target.name;
    if (name === 'id' || name === 'options[]') window.setTimeout(renderShippingDate, 0);
  });

  var shippingObserver = new MutationObserver(function () {
    var node = document.querySelector('[data-hh-juleklem-date]');
    if (node && (!node.getAttribute('data-hh-juleklem-rendered') || /Beregner/i.test(node.textContent))) {
      renderShippingDate();
    }
  });
  shippingObserver.observe(document.body, { childList: true, subtree: true });
  renderShippingDate();

  function enableReveals() {
    var root = document.getElementById('hh-juleklem-product');
    if (!root || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('hh-juleklem-motion');
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hh-juleklem-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    root.querySelectorAll('[data-hh-juleklem-reveal]').forEach(function (node) {
      revealObserver.observe(node);
    });
  }

  document.addEventListener('DOMContentLoaded', enableReveals);
  document.addEventListener('shopify:section:load', enableReveals);
})();
